module.exports = __webpack_public_path__ + "public/img/ppi_logo.cf5fad3.png";